import React from 'react';
import PropTypes from 'prop-types';
import localStyles from './styles.less';
import SchoolSvg from '../imagesSvg/schoolSvg';
import ImageUpload from '../../InlineEditorWizard/ImageUpload';
import WizardInput from '../Input';

const SchoolImageSelect = ({ image, schoolTitle, email, phone, setValue, t }) => (
  <WizardInput title={t('course.create.wizard.step6_1')} hint={t('wizard.hint.logo')}>
    <div className={localStyles.schoolphotoContainer}>
      <div className={localStyles.testWrapper}>
        <div className={localStyles.schoolPhoto}>
          {image ? (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <img src={image} alt="schoolImage" />
              <div className={localStyles.infoContainer}>
                <div>{schoolTitle}</div>
                <div>{email}</div>
                <div>{phone}</div>
              </div>
            </div>
          ) : (
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <SchoolSvg />
              <div className={localStyles.infoContainer}>
                <div>{schoolTitle}</div>
                <div>{email}</div>
                <div>{phone}</div>
              </div>
            </div>
          )}
        </div>
        <div className={localStyles.schoolPhotoButtonWrapper}>
          <ImageUpload
            uploadHandler={url => {
              setValue(url, 'schoolImage');
            }}
            type="school"
            folder="school"
            containerClassName="editCourseImage"
            school
            name="wizard_schoolImg_upload"
          />
        </div>
      </div>
    </div>
  </WizardInput>
);

SchoolImageSelect.propTypes = {
  image: PropTypes.string,
  schoolTitle: PropTypes.string,
  email: PropTypes.string,
  phone: PropTypes.any,
  setValue: PropTypes.func,
  t: PropTypes.func,
};

SchoolImageSelect.defaultProps = {
  image: '',
  schoolTitle: '',
  email: '',
  phone: '',
  setValue: () => {},
  t: () => {},
};

export default SchoolImageSelect;
